import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";

interface CyclePickerDialogProps {
  open: boolean;
  availableCycles: number[];
  onOpenChange: (open: boolean) => void;
  onSelect: (year: number) => void;
}

export function CyclePickerDialog({
  open,
  availableCycles,
  onOpenChange,
  onSelect,
}: CyclePickerDialogProps) {
  const [year, setYear] = useState<string>("");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Escolha o ciclo comercial</DialogTitle>
          <DialogDescription>
            Existe mais de um ciclo comercial disponível (ou nenhum publicado). Selecione o
            ciclo que deseja visualizar.
          </DialogDescription>
        </DialogHeader>
        <Select value={year} onValueChange={setYear}>
          <SelectTrigger>
            <SelectValue placeholder="Selecione o ciclo" />
          </SelectTrigger>
          <SelectContent>
            {availableCycles.map((cycle) => (
              <SelectItem key={cycle} value={String(cycle)}>
                {cycle}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <DialogFooter>
          <Button
            disabled={!year}
            onClick={() => onSelect(Number(year))}
          >
            Confirmar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
